import { createAsyncAction, createAction } from 'redux-promise-middleware-actions';
import { addAsyncActionPostfixes } from '../utils/actionTypeCreator';
import api from '../api/apiSettings';
import { convertToFormData } from '../utils/helpers';
import configData from '../config.json';

export const types = {
  SET_JOB: 'SET_JOB',
  ...addAsyncActionPostfixes({
    FETCH_JOBS: 'FETCH_JOBS',
    FETCH_NEXT_JOBS: 'FETCH_NEXT_JOBS',
    FETCH_SAVED_JOBS: 'FETCH_SAVED_JOBS',
    FETCH_NEXT_SAVED_JOBS: 'FETCH_NEXT_SAVED_JOBS',
    FETCH_APPLIED_JOBS: 'FETCH_APPLIED_JOBS',
    FETCH_NEXT_APPLIED_JOBS: 'FETCH_NEXT_APPLIED_JOBS',
    FETCH_JOBS_PUBLIC: 'FETCH_JOBS_PUBLIC',
    FETCH_NEXT_JOBS_PUBLIC: 'FETCH_NEXT_JOBS_PUBLIC',
    FETCH_RECOMENDED_JOBS: 'FETCH_RECOMENDED_JOBS',
    SAVE_JOB: 'SAVE_JOB',
    REMOVE_SAVED_JOB: 'REMOVE_SAVED_JOB',
    APPLY_JOB: 'APPLY_JOB',
    APPLY_JOB_V2: 'APPLY_JOB_V2',
    CHANGE_PAGE: 'CHANGE_PAGE',
    GET_COUNTERS: 'GET_COUNTERS',
    SET_APPLIED_JOB: 'SET_APPLIED_JOB',
    FILTER_JOBS_COUNT: 'FILTER_JOBS_COUNT',
    GET_SEARCH_SUGGESTION: 'GET_SEARCH_SUGGESTION'
  })
};

const preparePartOfURI = (key, arrayOfValues, isFirstCapital) => {
  return arrayOfValues.reduce(
    (result, value) =>
      `${result}${key}=${encodeURIComponent(
        (value.value && value.value.charAt(0).toUpperCase() + value.value.slice(1)) ||
          value.charAt(0).toUpperCase() + value.slice(1)
      )}&`,
    ''
  );
};

function fields(page, search) {
  let text = `PageNumber=${page?.active || page?.PageNumber}&`;
  text += `PageSize=${page?.limit || page?.PageSize}&`;
  text += search?.searchTxt ? `Field=${encodeURIComponent(search.searchTxt)}&` : '';
  text += search?.city ? `City=${encodeURIComponent(search.city.trim())}&` : '';
  text += search?.state ? `State=${encodeURIComponent(search.state.trim())}&` : '';
  text += search?.country ? `Country=${encodeURIComponent(search.country.trim())}&` : '';
  text += search?.location ? `Location=${encodeURIComponent(search.location)}&` : '';
  text += search?.industries?.length ? preparePartOfURI('Industry', search.industries) : '';
  text += search?.functions?.length ? preparePartOfURI('JobFunction', search.functions) : '';
  text += search?.contractTypes?.length ? preparePartOfURI('Contract_Type', search.contractTypes) : '';
  if (search?.remoteTypes?.length > 1) {
    text += `RemoteWork=2&`;
  } else {
    text += search?.remoteTypes?.length ? preparePartOfURI('RemoteWork', search.remoteTypes) : '';
  }
  text += search?.date || search.date === 0 ? `Date_Posted_Days=${encodeURIComponent(search.date)}&` : '';

  return text;
}

export const getCounters = createAsyncAction(types.GET_COUNTERS, () =>
  api.get(`v1/job/job-count`).then((res) => res.data)
);

export const fetchJobs = createAsyncAction(types.FETCH_JOBS, (page, search) =>
  api.get(`v1/jobs?${fields(page, search)}`).then((res) => res.data)
);

export const fetchNextJobs = createAsyncAction(types.FETCH_NEXT_JOBS, (page, search, filterPeriods) =>
  api.get(`v1/jobs?${fields(page, search, filterPeriods)}`).then((res) => res.data)
);

export const fetchSavedJobs = createAsyncAction(types.FETCH_SAVED_JOBS, (page, search, filterPeriods) =>
  api.get(`v1/job/saved-jobs?${fields(page, search, filterPeriods)}`).then((res) => res.data)
);

export const fetchNextSavedJobs = createAsyncAction(types.FETCH_NEXT_SAVED_JOBS, (page, search, filterPeriods) =>
  api.get(`v1/job/saved-jobs?${fields(page, search, filterPeriods)}`).then((res) => res.data)
);

export const fetchAppliedJobs = createAsyncAction(types.FETCH_APPLIED_JOBS, (page, search, filterPeriods) =>
  api.get(`v1/job-applications?${fields(page, search, filterPeriods)}`).then((res) => res.data)
);

export const fetchNextAppliedJobs = createAsyncAction(types.FETCH_NEXT_APPLIED_JOBS, (page, search, filterPeriods) =>
  api.get(`v1/job-applications?${fields(page, search, filterPeriods)}`).then((res) => res.data)
);

export const fetchJobsPublic = createAsyncAction(types.FETCH_JOBS_PUBLIC, (page, search, filterPeriods) =>
  api.get(`v1/job/public-jobs?${fields(page, search, filterPeriods)}`).then((res) => res.data)
);

export const fetchNextJobsPublic = createAsyncAction(types.FETCH_NEXT_JOBS_PUBLIC, (page, search, filterPeriods) =>
  api.get(`v1/job/public-jobs?${fields(page, search, filterPeriods)}`).then((res) => res.data)
);

export const setJob = createAction(types.SET_JOB, (job) => job);

// TODO: uri should be replaced
export const fetchRecommendedJobs = createAsyncAction(types.FETCH_RECOMENDED_JOBS, () =>
  api.get(`v1/job/recommendations?PageNumber=1&PageSize=3`).then((res) => res.data)
);

export const saveJob = createAsyncAction(types.SAVE_JOB, (id, userId, addToListImmediately = false) =>
  api
    .post(`v1/job/save-job`, { JobId: id, UserId: userId })
    .then((res) => ({ ...res.data, jobId: id, addToListImmediately }))
);

export const removeSavedJob = createAsyncAction(types.REMOVE_SAVED_JOB, (id, withDeleting = false) =>
  api.delete(`v1/job/remove-saved-job?jobId=${id}`).then((res) => ({ ...res.data, jobId: id, withDeleting }))
);

export const applyJob = createAsyncAction(
  types.APPLY_JOB,
  (
    job = {
      JobId: 0,
      UserId: 0,
      Answer1: '',
      Answer2: '',
      Answer3: ''
    }
  ) => api.post(`v1/job-application`, job).then((res) => res.data)
);

export const changePage = (page) => ({
  type: types.CHANGE_PAGE,
  payload: page
});

export const setAppliedJob = createAction(types.SET_APPLIED_JOB, (payload) => payload);

export const applyJobv2 = createAsyncAction(types.APPLY_JOB_V2, (data) => {
  const formDataBody = convertToFormData({
    ...data,
    Source: document.referrer ? new URL(document.referrer).origin : configData.REACT_APP_PUBLIC_URL
  });
  return api.post(`/v1/quick-job-application`, formDataBody).then((res) => res?.data);
});

export const applyJobEmbedded = createAsyncAction(types.APPLY_JOB_V2, (data) => {
  const formDataBody = convertToFormData({
    ...data
  });
  return api.post(`/v1/quick-job-application/save-airswift-application`, formDataBody).then((res) => res?.data);
});

export const filterJobsCount = createAsyncAction(types.FILTER_JOBS_COUNT, (search) =>
  api.get(`v1/job/filter-jobs-count?${fields({}, search, {})}`).then((res) => res.data)
);

export const getSearchSuggestion = createAsyncAction(types.GET_SEARCH_SUGGESTION, (search) =>
  api.get(`v1/jobs/get-search-suggestions?keyword=${search}`).then((res) => res.data)
);
